import { Action, createReducer, on } from '@ngrx/store';
import * as AppRootActions from '@app/app.actions';
import * as ProfileActions from '@profile/profile.actions';
import * as StrategyActions from '@strategy/strategy.actions';

import { Strategy3AState } from '@shared/models/Strategy';

export const STRATEGY_3A_REDUCER_FEATURE_KEY = 'strategy3A';

export const initialState: Strategy3AState = {
  isInitialized: false,
  riskSurveyQuestions: []
};

const strategy3AReducer = createReducer(
  initialState,
  on(StrategyActions.set3ARiskQuestions, (state, action) => ({
    ...state,
    isInitialized: true,
    riskSurveyQuestions: action.riskSurveyQuestions
  })),
  on(AppRootActions.switchAccount, ProfileActions.logout, () => ({ ...initialState }))
);

export function reducer(state: Strategy3AState, action: Action): Strategy3AState {
  return strategy3AReducer(state, action);
}
